const styles = theme => ({ // eslint-disable-line
  root: {
    flex: 1,
  },
  errorMessage: {
    color: theme.palette.error.dark,
  },
});
export default styles;
